import { useEffect } from "react";

import { reportApiUnreachable } from "@/lib/error-reports";
import { Button } from "@/components/ui/button";

export function InternalErrorPage() {
  useEffect(() => {
    reportApiUnreachable({
      apiUrl: import.meta.env.VITE_API_URL,
      online: navigator.onLine,
      referrer: document.referrer || undefined,
      href: window.location.href,
    });
  }, []);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4">
      <h1 className="text-4xl font-bold">Something went wrong</h1>
      <p className="text-muted-foreground">
        We can't reach our servers right now. Please try again in a moment.
      </p>
      <Button onClick={() => window.location.assign("/")}>Try again</Button>
    </div>
  );
}
